import { watchEffect, onUnmounted } from "vue";
import { markDirty, markClean } from "~/jose_modern/warn_unsaved_changes.js";

export function useWarnUnsavedChanges(isDirty) {
  const marker = document.createElement("input");

  watchEffect(() => {
    if (isDirty()) {
      markDirty(marker);
    } else {
      markClean(marker);
    }
  });

  onUnmounted(() => markClean(marker));
}
